var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component } from "react";
import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { encryptMessage } from "../../../../utils/encrption";
import { Icon, Icons } from "../../../atoms/icon";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import { CustomPin } from "../components/customPin";
import { FloatingLabel } from "../../../atoms/floating-label";
import * as styles from "../firstFlowModals/styles.css";
import { ErrorMessage } from "../components/errorMessage";
import { isHTMLInputElement } from "../../../../utils/common";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import Strings from "../../../../utils/hardcoded.json";
export class ResetSecurityQuestionCard extends Component {
    constructor(props) {
        super(props);
        this.handleInput = (e) => {
            const target = e.target;
            if (isHTMLInputElement(target)) {
                const isnumber = /^-?\d*$/.test(target.value);
                if (isnumber) {
                    const inputvalue = target.value;
                    const name = target.name;
                    const partialState = {};
                    partialState[name] = inputvalue;
                    this.setState(partialState, () => {
                        this.checkPinValidation();
                    });
                }
            }
        };
        this.checkPinValidation = () => {
            const { pin1, pin2, pin3, pin4 } = this.state;
            const pin = pin1.concat(pin2, pin3, pin4);
            if (pin.length === 4) {
                this.encrypt(pin);
            }
        };
        this.firstQuestion = (e) => {
            const target = e.target;
            if (isHTMLInputElement(target)) {
                const inputValue = target.value;
                const checkForEmpty = inputValue.replace(/\s/g, "").length;
                this.setState({
                    firstInputValue: inputValue,
                });
                if (checkForEmpty > 0) {
                    this.setState({
                        isButtonDisabledQone: true,
                    });
                }
                else {
                    this.setState({
                        isButtonDisabledQone: false,
                    });
                }
            }
        };
        this.secondQuestion = (e) => {
            const target = e.target;
            if (isHTMLInputElement(target)) {
                const inputValue = target.value;
                const checkForEmpty = inputValue.replace(/\s/g, "").length;
                this.setState({
                    secondInputValue: inputValue,
                });
                if (checkForEmpty > 0) {
                    this.setState({
                        isButtonDisabledQtwo: true,
                    });
                }
                else {
                    this.setState({
                        isButtonDisabledQone: false,
                    });
                }
            }
        };
        this.encryptAnswers = (text, text2) => __awaiter(this, void 0, void 0, function* () {
            const answer1 = text.toLowerCase();
            const answer2 = text2.toLowerCase();
            const encryptValueOne = yield encryptMessage(answer1);
            const encryptValueTwo = yield encryptMessage(answer2);
            this.props.onContinue(encryptValueOne, encryptValueTwo);
        });
        this.onContinueHandler = () => {
            const { firstInputValue, secondInputValue, disableButton } = this.state;
            const firstInput = firstInputValue.replace(/\s/g, "").length;
            const secondInput = secondInputValue.replace(/\s/g, "").length;
            if (firstInput > 0 && secondInput > 0 && disableButton) {
                this.encryptAnswers(firstInputValue, secondInputValue);
            }
        };
        this.state = {
            firstInputValue: "",
            secondInputValue: "",
            pin1: "",
            pin2: "",
            pin3: "",
            pin4: "",
            resetPin: "",
            isPinMatch: false,
            isButtonDisabledQone: false,
            isButtonDisabledQtwo: false,
            disableButton: false,
        };
    }
    encrypt(pin) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedValue = yield encryptMessage(pin);
            if (this.props.pinValidation === encryptedValue) {
                this.setState({ isPinMatch: false, disableButton: true });
            }
            else {
                this.setState({ isPinMatch: true, disableButton: false });
            }
        });
    }
    render() {
        const { pin1, pin2, pin3, pin4, firstInputValue, secondInputValue, isPinMatch, isButtonDisabledQone, isButtonDisabledQtwo, disableButton, } = this.state;
        return (React.createElement(Modal, { label: Strings.RESET_QUESTIONS, style: styles.container, showErrorMsg: isPinMatch, errorMsg: Strings.PIN_MISMATCH },
            React.createElement("div", { className: styles.questionCardContainer, id: "resetQuestWrapper" },
                React.createElement("div", { className: styles.resetCreatePinWrapper, id: "resetHeader" },
                    React.createElement("div", { className: styles.goBack, onClick: () => this.props.onBack(), id: "backArrow" },
                        React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
                    React.createElement(Typography, { classNameM: M.of(styles.questionHeader), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, Strings.RESET_QUESTIONS))),
                React.createElement("div", { className: styles.subHeaderWrapper, id: "resetQuestSubHeader" },
                    React.createElement(Typography, { classNameM: M.of(styles.subHeader), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, Strings.RESET_SECURITY_QUESTIONS))),
                React.createElement("div", { className: styles.pinWrapper, id: "yourPin" },
                    React.createElement(CustomPin, { label: Strings.YOUR_PIN, handleInput: this.handleInput, pin1: pin1, pin2: pin2, pin3: pin3, pin4: pin4, name: "pin", nextFocusID: "pin4" })),
                isPinMatch && React.createElement(ErrorMessage, { children: Strings.PIN_MISMATCH }),
                React.createElement("div", { className: styles.answerWrapper, id: "firstQuest" },
                    React.createElement(FloatingLabel, { label: "What is your favorite animal?", handleInput: this.firstQuestion, value: firstInputValue })),
                React.createElement("div", { className: styles.answerWrapper, id: "secondQuest" },
                    React.createElement(FloatingLabel, { label: "What is the name of your birthplace?", handleInput: this.secondQuestion, value: secondInputValue })),
                React.createElement("div", { className: cn(styles.buttonWrapper, styles.wrapperTop) },
                    React.createElement("div", { id: "resetQuestContinueButton" },
                        React.createElement(Button, { children: Strings.CONTINUE, variant: isButtonDisabledQone && isButtonDisabledQtwo && disableButton
                                ? ButtonVariant.Primary
                                : ButtonVariant.Disabled, onClickM: M.of(() => this.onContinueHandler()) }))))));
    }
}

